export default __webpack_public_path__ + "static/media/thumb-NavIC-Chip-1.b1e0453b.png";